<template>
  <div class="space-y-6">
    <div class="bg-white rounded-lg border border-gray-200">
      <div :class="[FILTER_BAR, 'px-4 py-3 border-b border-gray-200']" data-test="filter-bar">
        <FilterDropdown class="w-32" full-width label="Family" :model-value="view.family === 'all' ? null : view.family" :options="FAMILIES" placeholder="All" clearable @update:model-value="view.family = $event || 'all'" />
        <FilterCheckbox v-model="showInactive" label="Show inactive" />
        <router-link v-if="superuser" :to="{ name: 'AdminHermesHat', params: { hatName: 'new' } }" :class="[PRIMARY_BUTTON, 'ml-auto', error ? 'pointer-events-none opacity-50' : '']">New hat</router-link>
      </div>
      <div v-if="error" class="m-4 rounded-md bg-red-tint px-4 py-3 text-gray-900"><strong>Hats could not be loaded.</strong> {{ error }} <button type="button" :class="[TEXT_BUTTON, 'ml-3']" @click="load">Retry</button></div>
      <table v-else class="w-full table-fixed divide-y divide-gray-200">
        <colgroup><col style="width:22%"><col style="width:10%"><col style="width:30%"><col style="width:20%"><col style="width:10%"><col style="width:8%"></colgroup>
        <thead class="bg-gray-50"><tr>
          <th :class="TH">Hat</th><th :class="TH">Family</th><th :class="TH">Switches on</th><th :class="TH">Leads to</th>
          <th :class="TH">Updated</th><th :class="TH">Active</th>
        </tr></thead>
        <tbody class="divide-y divide-gray-200">
          <template v-if="loading"><tr v-for="n in 4" :key="n"><td v-for="c in 6" :key="c" :class="TD"><div class="h-4 rounded bg-gray-100" /></td></tr></template>
          <tr v-else-if="!shown.length"><td colspan="6" class="px-3 py-8 text-center text-gray-500">{{ hats.length ? 'No hats match this filter.' : 'No hats yet.' }}</td></tr>
          <tr v-for="h in shown" v-else :key="h.name">
            <td :class="TD">
              <router-link :to="{ name: 'AdminHermesHat', params: { hatName: h.name } }" class="font-medium text-neutral-800">{{ h.label }}</router-link>
              <div class="text-gray-500">{{ h.name }}</div>
            </td>
            <td :class="TD">{{ FILTER_LABELS[h.family] }}</td>
            <td :class="TD">
              <span v-for="k in WHEN_KEYS" :key="k" class="inline-block rounded bg-gray-100 px-2 mr-1 mb-1">{{ ((h.wearing_when || {})[k] || []).length }} {{ k }}</span>
              <div class="text-gray-500 truncate" :title="h.description">{{ h.description }}</div>
            </td>
            <td :class="TD">
              <span v-for="l in h.leads_to" :key="l.hat" class="inline-block rounded bg-gray-100 px-2 mr-1 mb-1">{{ labelOf(l.hat) }}</span>
              <span v-if="!(h.leads_to || []).length" class="text-gray-500">None</span>
            </td>
            <td :class="TD" :title="absolute(h.updated_at)">{{ relative(h.updated_at) }}</td>
            <td :class="TD"><HermesBadge :value="h.is_active ? 'active' : 'inactive'" :label="h.is_active ? 'Active' : 'Off'" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { FILTER_BAR } from '@/components/widgetcomponents/library/filterBox';
import FilterCheckbox from '@/components/widgetcomponents/library/FilterCheckbox.vue';
import FilterDropdown from '@/components/widgetcomponents/library/FilterDropdown.vue';
import queryState from '@/mixins/queryState';
import HermesBadge from './HermesBadge.vue';
import { API, PRIMARY_BUTTON, TD, TEXT_BUTTON, TH, absolute, errorOf, relative } from './hermes';

const WHEN_KEYS = ['words', 'tables', 'tools'];
const FILTER_LABELS = { all: 'All', subject: 'Subject', activity: 'Activity' };
const FAMILIES = [{ value: 'subject', label: 'Subject' }, { value: 'activity', label: 'Activity' }];

export default {
  name: 'HermesHats',
  components: { FilterCheckbox, FilterDropdown, HermesBadge },
  mixins: [queryState('view', { family: 'all' })],
  data() {
    return { FAMILIES, FILTER_BAR,
      hats: [], loading: true, error: '', showInactive: false,
      WHEN_KEYS, FILTER_LABELS, PRIMARY_BUTTON, TD, TEXT_BUTTON, TH,
    };
  },
  computed: {
    superuser() {
      return !!this.$store.getters['auth/current_user']?.is_superuser;
    },
    shown() {
      return this.hats
        .filter((h) => this.showInactive || h.is_active)
        .filter((h) => this.view.family === 'all' || h.family === this.view.family);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    absolute, relative,
    async load() {
      this.loading = true;
      this.error = '';
      try {
        this.hats = (await this.$axios.get(`${API}/hats/`)).data;
      } catch (e) {
        this.error = errorOf(e, 'Try again in a moment.');
      } finally {
        this.loading = false;
      }
    },
    labelOf(name) {
      return (this.hats.find((h) => h.name === name) || {}).label || name;
    },
  },
};
</script>
